module.exports = __webpack_public_path__ + "static/media/dashboards-standard.1f7406e6.png";